import { Col } from 'react-bootstrap';
import { HomeLink } from './HomeLink';

type ErrorContentProps = {
  title: string;
  children?: React.ReactNode;
};

export const ErrorContent = ({ title, children }: ErrorContentProps) => (
  <Col xs={12} className="text-center">
    <h3 className="mt-3 mb-4 error-message">{title}</h3>
    {children}
    <HomeLink />
  </Col>
);
